import { MatchFromJSON, type Match } from '../models/Match';
import { BaseAPI } from '../runtime';
import { getApiConfigNext } from './index';

type MatchTeam = NonNullable<Match['teamA']>;
export type MatchTeamWithColor = Omit<MatchTeam, 'details'> & {
  details?: MatchTeam['details'] & { matchColor?: string | null };
};
export type MatchWithColors = Omit<Match, 'teamA' | 'teamB'> & {
  teamA?: MatchTeamWithColor;
  teamB?: MatchTeamWithColor;
};

/** Preserve match-only fields absent from the older generated team model. */
export function matchWithColorsFromJSON(value: unknown): MatchWithColors {
  const match: MatchWithColors = MatchFromJSON(value);
  const raw = value as { permissions?: unknown; teamA?: { details?: Record<string, unknown> }; teamB?: { details?: Record<string, unknown> } };
  if (raw?.permissions != null) Object.assign(match, { permissions: raw.permissions });
  for (const side of ['teamA', 'teamB'] as const) {
    const team = match[side];
    const details = raw?.[side]?.details;
    const color = details?.match_color ?? details?.matchColor;
    if (team && typeof color === 'string') {
      match[side] = { ...team, details: { ...team.details, matchColor: color } };
    }
  }
  return match;
}

class MatchColorReadApi extends BaseAPI {
  async get(matchId: string): Promise<MatchWithColors> {
    const response = await this.request({ path: `/matches/${encodeURIComponent(matchId)}`, method: 'GET', headers: {} });
    return matchWithColorsFromJSON(await response.json());
  }
}

export async function getMatchWithColors(matchId: string): Promise<MatchWithColors> {
  return new MatchColorReadApi(await getApiConfigNext()).get(matchId);
}
